let api_address
switch (process.env.VUE_APP_MODE) {
  case 'development':
    api_address = 'http://devorg.jkdata.aijiayi.com'    // 开发环境url
    break
  case 'test':
    api_address = 'http://devorg.jkdata.aijiayi.com'   // 测试环境url
    break
  case 'production':
    api_address = 'https://orgapi.jkdata.aijiayi.com'    // 生产环境url
    break
  case 'pre':
        api_address = 'http://preorgapi.jkdata.aijiayi.com'    // 预发布url
        break
  default:
    api_address = 'http://devorg.jkdata.aijiayi.com'    
    // api_address = 'https://orgapi.jkdata.aijiayi.com'    // 生产环境url
}

export default {
  baseUrl: api_address
}

// 跨域代理
// let api_address
// switch (process.env.VUE_APP_MODE) {
//   case 'development':
//     api_address = '/api'
//     break
//   case 'test':
//     api_address = '/api'
//     break
//   case 'production':
//     api_address = '/api'
//     break
//   default:
//     api_address = '/api'
// }

// export default {
//   baseUrl: api_address
// }
